import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useJWTAuth, useJWTAuthActions } from "../../../services/JWTAuthProvider";
import { userRole } from '../../../constants/appConst';
import useOutsideClick from '../../../lib/useOutsideClick';
import { ChangePassword } from '../../change-password';
import config from '../../../config';

export const FixHeader = () => {
    const { user } = useJWTAuth();
    const { logout } = useJWTAuthActions();
    const [isVisible, setVisible] = useState(false);
    const wrapperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const navigateToLogOut = async () => {
        await logout();
    };

    useOutsideClick(wrapperRef, () => setVisible(false))

    return (
        <>
            <div className='header-fix'>
                <div className='left-head'>
                    <div className='item open-menu'>
                        <img src='/Assets/menu-icon.svg' alt='Menu' />
                    </div>
                </div>

                <div className='right-head'>
                    {(user.role === userRole.GlobalAdmin || user.role === userRole.BusinessUnitAdmin) ? (
                        <Link to="/usermanagement">
                            <div className='item'>
                                <img src='/Assets/user-management.svg' alt='User Management' />
                                <span className='hide-mob'>User Management</span>
                            </div>
                        </Link>
                    ) : null}
                    <div ref={wrapperRef} className='item user-box'>
                        <div className='open-user-pop' onClick={() => setVisible(!isVisible)}>
                            <img src='/Assets/user-pic.svg' alt='User Pic' />
                            <img src='/Assets/top-dd.svg' alt='DropDown Symbol' />
                        </div>
                        <div className={`user-profile-pop ${isVisible ? 'visible' : 'hidden-fix'}`}>
                            <div className='user-detail-box'>
                                <div className='pop-user-pic'>
                                    <img src='/Assets/user-pic.svg' alt='User Pic' />
                                </div>
                                <div className='pop-user-name'>
                                    <p><strong>{user.name}</strong></p>
                                    <p>{user.roleName}</p>
                                    <p>{user.email}</p>
                                </div>
                                <div className='clear'></div>
                            </div>
                            {
                                config.SSODOMAIN.findIndex((val) => user.email.toLowerCase().includes(val)) >= 0 ? null :
                                    <div className='user-setting'>
                                        <div className='user-custom' onClick={() => setIsOpen(true)}>
                                            <span><img src='/Assets/edit.svg' alt='Change Password' /></span>
                                            Change Password
                                        </div>
                                    </div>
                            }
                            <div className='user-setting'>
                                <div className='user-custom' onClick={navigateToLogOut}>
                                    <span><img src='/Assets/logout.svg' alt='Logout' /></span>
                                    Logout
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ChangePassword isOpen={isOpen} closeCallback={() => setIsOpen(false)} />
        </>
    )
}